import React from 'react';
import type { Milestone } from '../data/constants.js';
import { formatVal, formatTarget } from '../data/helpers.js';
import './milestone-bar.css';

interface MilestoneBarProps {
  milestone: Milestone;
  loading?: boolean;
}

function getColorTier(pct: number): 'green' | 'amber' | 'accent' {
  if (pct >= 75) return 'green';
  if (pct >= 40) return 'amber';
  return 'accent';
}

export function MilestoneBar({ milestone, loading }: MilestoneBarProps): React.ReactElement {
  const pct = Math.min((milestone.current / milestone.target) * 100, 100);
  const tier = getColorTier(pct);
  const blurClass = loading ? ' mc-milestone--loading' : '';

  return (
    <div className="mc-milestone">
      <div className="mc-milestone__header">
        <div className="mc-milestone__label-group">
          <span className="mc-milestone__label">{milestone.label}</span>
          <span className="mc-milestone__weight">{(milestone.weight * 100).toFixed(0)}%</span>
        </div>
        <div className={`mc-milestone__values${blurClass}`}>
          <span className="mc-milestone__current">{formatVal(milestone)}</span>
          <span className="mc-milestone__target">/ {formatTarget(milestone)}</span>
        </div>
      </div>
      <div className={`mc-milestone__track${blurClass}`}>
        <div
          className={`mc-milestone__fill mc-milestone__fill--${tier}`}
          style={{ width: `${pct}%` }}
        >
          <div className={`mc-milestone__fill-cap mc-milestone__fill-cap--${tier}`} />
        </div>
      </div>
      <div className={`mc-milestone__pct${blurClass}`}>{pct.toFixed(0)}%</div>
    </div>
  );
}
